/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { OrderListResponse } from '../../models/order-list-response';

export interface OrderControllerGetAll$Params {
  maintenance_only?: boolean;
  product_code_internal?: string;
  related_agreement_id?: number;
  registry_id?: number;
  identifier?: string;
  references?: string;
  product_id?: Array<number>;
  status_id?: number;
  created_from_date?: string;
  created_to_date?: string;
  limit: number;
  skip: number;
  related_status_workflow_id?: number;
  order_by?: string;
  order_direction?: string;
}

export function orderControllerGetAll(http: HttpClient, rootUrl: string, params: OrderControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, orderControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('maintenance_only', params.maintenance_only, {});
    rb.query('product_code_internal', params.product_code_internal, {});
    rb.query('related_agreement_id', params.related_agreement_id, {});
    rb.query('registry_id', params.registry_id, {});
    rb.query('identifier', params.identifier, {});
    rb.query('references', params.references, {});
    rb.query('product_id', params.product_id, {});
    rb.query('status_id', params.status_id, {});
    rb.query('created_from_date', params.created_from_date, {});
    rb.query('created_to_date', params.created_to_date, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('related_status_workflow_id', params.related_status_workflow_id, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: OrderListResponse;
      }>;
    })
  );
}

orderControllerGetAll.PATH = '/order';
